import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { LearningModulesPageRoutingModule } from "./learning-modules-routing.module";
import { LearningModulesPage } from "./learning-modules.page";
import { TranslateModule } from "@ngx-translate/core";
import { BackgroundImageDirectiveModule } from "src/app/directives/background-image/background-image.module";
import { IsModuleUnlockedPipeModule } from "src/app/pipes/is-module-unlocked/is-module-unlocked.module";
import { IsModuleUnlockedPipe } from "src/app/pipes/is-module-unlocked/is-module-unlocked.pipe";
import { ChallengeLockedPageModule } from "../../modals/challenge-locked/challenge-locked.module";
import { LearningModulesDefaultImageModule } from "src/app/pipes/learning-modules-default-image/learning-modules-default-image.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LearningModulesPageRoutingModule,
    TranslateModule,
    BackgroundImageDirectiveModule,
    IsModuleUnlockedPipeModule,
    ChallengeLockedPageModule,
    LearningModulesDefaultImageModule,
  ],
  providers: [IsModuleUnlockedPipe],
  declarations: [LearningModulesPage],
})
export class LearningModulesPageModule {}
